import React from 'react';
import AvatarCropper from "./AvatarCropper";
import Uploader from './Uploader'

const DEFAULT_AVATAR = "/images/user-avatar.jpg";

class Avatar extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedImage: null,
			value: props.value || DEFAULT_AVATAR,
			cropperOpen: false
		};
	}

	onFileChanged = (fileURI) => {
		this.setState({
			selectedImage: fileURI,
			cropperOpen: true
		});
	}

	onCrop = (dataURI) => {
		this.setState({
			value: dataURI,
			cropperOpen: false
		}, function () {
			this.props.onFieldChange(dataURI, this.props.name, this.props.onChange);
		});
	}

	onHide = () => {
		this.setState({
			cropperOpen: false
		});
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.state.value)
			this.setState({ value: nextProps.value || DEFAULT_AVATAR });
	}

	shouldComponentUpdate(nextProps, nextState) {
		return true;
	}

	render() {
		return (
			<React.Fragment>
				<div className="avatar-photo">
					<Uploader onFileChanged={this.onFileChanged} />
					<div className="avatar-edit">
					</div>
					<img src={this.state.value} style={{ width: "150px", height: "150px" }} alt="avatar" />
				</div>
				{this.state.cropperOpen &&
					<AvatarCropper
						onRequestHide={this.onHide}
						cropperOpen={this.state.cropperOpen}
						onCrop={this.onCrop}
						image={this.state.selectedImage}
						modalSize="small"
						width={200}
						height={200}
					/>
				}
			</React.Fragment>);
	}
}


// Mark this as a form component
Avatar.defaultProps = {
	formControl: true,
	managed: false
};

export default Avatar;



// WEBPACK FOOTER //
// ./src/fw/forms/controls/avatar/Avatar.js